import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/projects/chatsc_web/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/projects/chatsc_web/node_modules/@mui/material/esm/Button/Button.js");
;
import(/* webpackMode: "eager" */ "/home/app/projects/chatsc_web/node_modules/@mui/material/esm/Grid/Grid.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/projects/chatsc_web/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/app/projects/chatsc_web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/app/projects/chatsc_web/src/assets/images/background-chatsc.png");
;
import(/* webpackMode: "eager" */ "/home/app/projects/chatsc_web/src/assets/images/chatsc-logo-login-dark.png");
;
import(/* webpackMode: "eager" */ "/home/app/projects/chatsc_web/src/assets/images/chatsc-logo-login-light.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/app/projects/chatsc_web/src/components/global/layout/DefaultLayout.tsx");
